import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from './core/core.module';
import { LoginComponent } from './membership/login/login.component';
import { PageNotFoundComponent } from './core/page-not-found/page-not-found.component';
import { AuthGuard } from './membership/auth.guard';
import { DeleteProfileComponent } from './membership/delete-profile/delete-profile.component';
import { SendOtpComponent } from './membership/send-otp/send-otp.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    title: 'Paquik'
  },
  {
    path: 'delete-account-step1',
    component: SendOtpComponent,
    title: 'Paquik'
  },
  {
    path: 'delete-account-step2',
    component: DeleteProfileComponent,
    title: 'Paquik'
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => CoreModule,
  },
  {
    path: '',
    redirectTo: '/home/page/overview',
    pathMatch: 'full',
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
